import { render } from "./Sidebar.vue?vue&type=template&id=11d722b7&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=11d722b7&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=11d722b7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11d722b7"

export default script